import { RefObject, useEffect } from 'react';
type Event = MouseEvent | TouchEvent;

function useOutsideClick<T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: (event: Event) => void,
): void {
  useEffect(() => {
    const listener = (event: Event) => {
      const el = ref?.current;
      // Do nothing if clicking ref's element or descendent elements
      if (!el || el.contains((event?.target as Node) || null)) {
        return;
      }
      setTimeout(() => {
        handler(event);
      }, 100);
    };
    document.addEventListener(`mouseup`, listener);
    document.addEventListener(`touchend`, listener);
    return () => {
      document.removeEventListener(`mouseup`, listener);
      document.removeEventListener(`touchend`, listener);
    };
    // Reload only if ref or handler changes
  }, [ref, handler]);
}
export default useOutsideClick;
